import it from './privacy.it.json';
import en from './privacy.en.json';

const privacyContent = { it, en };

export default privacyContent;
